import { Zap } from "lucide-react";
import { useNavigate } from "react-router-dom";
import Chapters from "../CommanComponents/Chapters";
export default function ClassroomDemo() {
  const navigate = useNavigate();

  return (
    <main
      className="max-w-7xl mx-auto px-4 py-12 sm:px-6 lg:px-8"
      style={{
        fontFamily: "Inter, system-ui, -apple-system, sans-serif ",
      }}
    >
      {/* Hoş Geldiniz & Paket Seçimi */}

      <div className="text-center max-w-3xl mx-auto mb-10">
        <h2 className="text-4xl font-black text-purple-600 mb-4">
          İngilizce Yolculuğuna Başla! 👋
        </h2>
        <p className="text-lg text-gray-500 leading-relaxed">
          İlkokul öğrencileri için{" "}
          <span className="text-purple-600 font-bold underline decoration-2">
            MEB müfredatına tam uyumlu{" "}
          </span>
          eğlenceli ve etkileşimli eğitim platformu.
        </p>
      </div>
      <div className="bg-white rounded-3xl p-8 mb-12 border border-gray-100 flex-1 flex-col md:flex-row items-center gap-10">
        <div className="flex-1">
          <h3 className="text-2xl font-bold text-gray-500 mb-6 flex items-center gap-2">
            <Zap className="text-yellow-500 fill-yellow-500" /> Neden Bizimle
            Öğrenmelisin?
          </h3>
          <div className="grid sm:grid-cols-2 gap-4">
            {[
              "Her Sınıfa ait 100+ fazla  İnteraktif Alıştırma",
              "Kelime,dil bilgisi,okuma,ve konuşma Odaklı",
              "Her bir alıştırma bellirli tekrar sayısın sahip",
              "Her bir alıştırma 3 aşamada oluşur",
              "bu aşamalar kolaydan zora sıralanmıştır",
              "Öğretmen Kontrol Paneli mevcut",
              "Öğretmen öğrencileri için sınırsız sınıf açabilir ",
              "Her sınıftaki öğrencileri ödev verme ödev kontrolu yapabilir.",
              "Öğretmen  üyelik girişi ile bu hizmeti alabilir",
              "öğretmen belli bir öğrenci kotasını sahip olduğunda sınıf alıştırmalarını ücretsiz erişebilir",
              "Anlık Geri Bildirim Sistemi ",
              "Eğlenceli Rozet Sistemi",
            ].map((feature, i) => (
              <div key={i} className="flex items-center gap-2 text-gray-700">
                <div className="w-5 h-5 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-green-600 text-xs">✓</span>
                </div>
                <span className="font-medium">{feature}</span>
              </div>
            ))}
          </div>
        </div>
        {/* --- PAKET SATIN ALMA ÇAĞRISI --- */}
        <div className=" mt-4 relative overflow-hidden bg-gradient-to-r from-purple-50 to-white border-2 border-purple-100 rounded-[2.5rem] p-2 md:p-4 shadow-sm  gap-6">
          {/* Sol Taraf: Metin ve İkon */}
          {/* Sağ Taraf: Fiyat/Buton Alanı */}
          <div className="flex flex-col sm:flex-row items-center  justify-between gap-4 w-full md:w-auto">
            <div className="flex flex-col items-center md:items-end mr-2">
              <span className="text-xs font-bold text-purple-400 uppercase tracking-widest">
                Avantajlı Fiyat
              </span>
              <span className="text-3xl font-black text-gray-900">
                Şimdi Başla!
              </span>
            </div>

            <button
              onClick={() => navigate("/purchase")}
              className="group relative w-full sm:w-auto bg-orange-500 hover:bg-orange-600 text-white px-10 py-5 rounded-2xl text-lg font-black transition-all hover:scale-105 active:scale-95 shadow-lg shadow-orange-200 overflow-hidden"
            >
              {/* Parlama Efekti */}
              <div className="absolute inset-0 w-full h-full bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:animate-[shimmer_1.5s_infinite]" />

              <span className="relative flex items-center justify-center gap-2">
                Paketi Hemen Al
                <svg
                  className="w-5 h-5 group-hover:translate-x-1 transition-transform"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={3}
                    d="M13 7l5 5m0 0l-5 5m5-5H6"
                  />
                </svg>
              </span>
            </button>
          </div>
        </div>
      </div>
      {/* Örnek Alıştırma Bölümü */}
      <div className="bg-white rounded-3xl shadow-sm border border-gray-100 p-8 mb-12 overflow-hidden">
        <div className="text-center mb-10">
          <span className="bg-purple-500 text-white px-4 py-1 rounded-full text-sm font-bold uppercase tracking-wider">
            Ücretsiz Deneme
          </span>
          <h3 className="text-3xl font-bold text-gray-900 mt-4 mb-2">
            Örnek Alıştırmayı Deneyin
          </h3>
          <p className="text-gray-500">
            2. Sınıf "Words" ünitesine ait örnek çalışmaları aşağıdan
            inceleyebilirsiniz.
          </p>
        </div>
        <div className="bg-gray-50 rounded-2xl p-4 ">
          <Chapters selection="words" />
        </div>
      </div>
    </main>
  );
}
